import { Loader2 } from 'lucide-react';

interface FullPageLoaderProps {
  label: string;
}

export const FullPageLoader = ({ label }: FullPageLoaderProps) => {
  return (
    <div
      role="status"
      className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-gray-50 px-4 text-center"
    >
      <Loader2
        aria-hidden="true"
        className="h-8 w-8 animate-spin text-blue-600 motion-reduce:animate-none"
      />
      <span className="text-sm text-slate-500">{label}</span>
    </div>
  );
};
